export const rootCss = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  marginBottom: "24px",
  width: "100%",

  // Leaving these here until we make a decision about dimensions. May happen in a later ticket.
  // [mediaQuery.downTo(sm)]: {
  //   maxWidth: '724px',
  // },

  // [mediaQuery.downTo(md)]: {
  //   maxWidth: '905px',
  // },
};

export const detailsRootCss = {
  marginBottom: "24px",
};
